import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: block;

  .file-upload {
    &-drag {
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px dashed #5b36f2;
      border-radius: 4px;
    }

    &-drag.disable {
      border: 1px dashed #8090bb !important;
    }

    &-actions {
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > span {
        font-size: 12px;
        color: #161d1f;
      }
    }

    &-items {
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    &-button {
      height: 40px;
      padding-left: 16px;
      padding-right: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      border-radius: 4px;
      // background-color: #ffffff;

      > span {
        font-weight: 700;
        font-size: 12px;
        color: #5b36f2;
      }

      &:hover {
        background-color: #e2dffd;
      }

      &:focus {
        background-color: #c6c0fc;
      }

      &:active {
        background-color: #c6c0fc;
      }
    }

    // ///// DISABLE DRAG AND DROP

    &-drag.disable {
      width: 100%;
      cursor: not-allowed !important;
    }

    &-button.disable {
      pointer-events: none;

      > span {
        color: #8090bb !important;
      }
      > cc-icon {
        color: #8090bb !important;
      }
    }
  }
`;
